import React from 'react';
import PdfViewer from '../core/PdfViewer';

const Terms = (props) => {
    return (
        <PdfViewer url="https://dynki.com/assets/terms-of-service.pdf"/>
    )
}

export default Terms;